import { POST, GET } from '@/utils/request'
import Api from './url'

export const getHonourExplain = async (params: object) => {
  return await GET({
    url: Api.getHonourExplain,
    params
  })
}
